module.exports = __webpack_public_path__ + "static/Moonlighter3-da1957be6a041345f1c4c48b97295584.webp";